<template>
  <div
    class="live-editor-op-cell"
    :class="rootClass"
    :title="cellTitle"
    @click="onClick"
  >
    <span class="live-editor-op-plan">计划 {{ planText }}</span>
    <span class="live-editor-op-stage" :class="stageClass">
      <i v-if="loading" class="el-icon-loading live-editor-op-stage__spin" />
      <template v-else>{{ stageLine }}</template>
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'LiveEditorOpStageCell',
  props: {
    planText: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    done: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    interactive: { type: Boolean, default: true },
  },
  computed: {
    hasValue(): boolean {
      return this.value !== '' && this.value != null;
    },
    stageLine(): string {
      if (this.hasValue) return `${this.label} ${String(this.value)}`;
      return this.label;
    },
    rootClass(): Record<string, boolean> {
      return {
        'live-editor-op-cell--done': this.done,
        'live-editor-op-cell--none': !this.done,
        'live-editor-op-cell--interactive': this.interactive && !this.loading,
        'live-editor-op-cell--static': !this.interactive || this.loading,
      };
    },
    stageClass(): Record<string, boolean> {
      return {
        'live-editor-op-stage--empty': !this.hasValue,
        'live-editor-op-stage--filled': this.hasValue,
      };
    },
    cellTitle(): string {
      if (!this.interactive || this.loading) return '';
      if (this.hasValue) return `查看或修改${this.label}`;
      return `点击将${this.label}记为今天`;
    },
  },
  methods: {
    onClick() {
      if (!this.interactive || this.loading) return;
      this.$emit('click');
    },
  },
});
</script>

<style lang="scss" scoped>
.live-editor-op-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  min-height: 52px;
  padding: 6px 8px;
  border: 1px solid $color-hairline;
  border-radius: $border-radius-sm;
  background: #fafbfd;
  box-sizing: border-box;
  user-select: none;

  &--done {
    border-color: #cfe6d5;
    background: #eef7f0;
  }

  &--interactive {
    cursor: pointer;

    &:hover {
      border-color: rgba($color-primary, 0.45);
      box-shadow: 0 0 0 1px rgba($color-primary, 0.08);
    }
  }

  &--static {
    cursor: default;
  }
}

.live-editor-op-plan {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  color: $color-text-regular;
  white-space: nowrap;
  text-align: center;
}

.live-editor-op-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  min-height: 26px;
  padding: 5px 8px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
  box-sizing: border-box;

  &--empty {
    border: 1px solid #dcdfe6;
    background: #fff;
    font-weight: 600;
    color: $color-text-regular;
  }

  &--filled {
    border: 1px solid transparent;
    background: transparent;
    font-weight: 500;
    color: $color-text-regular;
  }

  &__spin {
    font-size: 14px;
    color: $color-primary;
  }
}
</style>
